import { render, staticRenderFns } from "./AccessPermitRequestVehicle.vue?vue&type=template&id=149a372a&scoped=true&"
import script from "./AccessPermitRequestVehicle.vue?vue&type=script&lang=js&"
export * from "./AccessPermitRequestVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149a372a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VFileInput,VRadio,VRadioGroup,VTextarea})
